import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";

import { Modal } from "components/Modal";
import { CssButton, CssIcon } from "styles/helpers/layout";

export const StyledModal = styled(Modal)`
  width: 50rem;
  max-width: 100%;
  border-radius: 1rem;
`;

export const StyledSupportButton = styled(CssButton)`
  align-self: flex-start;
  margin-top: 1rem;
  padding: 0.25rem 1rem;
  font-size: ${(props: ThemeProps) => props.theme.font.size._14};

  color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  background-color: ${(props: ThemeProps) => props.theme.palette.neutral._999};

  ${CssIcon} {
    color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  }

  :hover {
    color: ${(props: ThemeProps) => props.theme.palette.neutral._400};
    background-color: ${(props: ThemeProps) => props.theme.palette.neutral.white};

    ${CssIcon} {
      color: ${(props: ThemeProps) => props.theme.palette.neutral._400};
    }
  }
`;
